module.exports = __webpack_public_path__ + "img/loader.2e50555c.svg";